/** @type {import('tailwindcss').Config} */
module.exports = {
  mode: 'jit',
  corePlugins: {
    preflight: false,
    container: false
  },
  purge: [
    './src/**/*.vue',
    './src/**/*.js'
  ],
  darkMode: false,
  content: [],
  theme: {
    colors: {
      transparent: 'transparent',
      black: '#000',
      white: '#FFF',
      offWhite: '#F8F8F8',
      blue: '#0095E6',
      blueHover: '#00ABE8',
      darkBlue: '#00183D',
      midBlue: '#10C2EE',
      brightBlue: '#3FE4FB',
      purple: '#9664FF',
      warn: '#FD9A05',
      danger: '#EB4869',
      dangerHighlight: '#E82C52',
      secondaryHover: '#10BFFF',
      success: '#10DAC1',
      error: '#EB4869',
      pink: '#FF73C7',
      lightGray: '#F8F8F8',
      darkGray: '#4B4B4B',
      disabledGrey: '#BBB',
      skeleton: '#EBEBEB'
    },
    fontFamily: {
      'display': ['Roboto Slab', 'serif'],
      'body': ['Roboto', 'sans-serif']
    },
    fontSize: {
      12: '12px',
      14: '14px',
      16: '16px',
      body: '18px',
      small: '14px',
      large: 'clamp(1.5rem, 3vw, 2.2rem)',
      hero: 'clamp(2rem, 7vw, 3.5rem)'
    },
    lineHeight: {
      large: '1.2em',
      hero: '1em',
      skeleton: '1.5rem'
    },
    fontWeight: {
      normal: 400,
      semibold: 600,
      bold: 700
    },
    borderRadius: {
      0: '0',
      small: '5px',
      normal: '8px',
      large: '26px',
      full: '100%'
    },
    dropShadow: {
      none: '0 0 0 #0000',
      button: '0 2px 4px rgba(0, 0, 0, 0.25)',
      buttonLight: '0 2px 4px rgba(0, 0, 0, 0.15)'
    },
    borderWidth: {
      0: '0',
      1: '1px'
    },
    backgroundOpacity: {
      30: '0.3',
      100: '1'
    },
    extend: {
      spacing: {
        lButtonXPadding: '32px',
        lButtonYPadding: '16px',
        base: '15px',
        sm: '10px',
        twenty: '20px',
        boxOffset: '0.85em',
        iconSize: '0.85em',
        iconGap: '0.3em',
        iconOffset: '1.15em'
      },
      borderWidth: {
        3: '3px'
      }
    }
  },
  plugins: [
    require('tailwindcss-children'),
    // tailwind 2 doesn't support aspect ratio so adding it here
    function ({ matchUtilities, theme }) {
      matchUtilities(
        {
          'aspect': (value) => ({
            'aspect-ratio': value
          })
        },
        {
          values: {
            '6/5': '6 / 5',
            '5/4': '5 / 4',
            '4/3': '4 / 3'
          }
        }
      )
    }
  ]
}
